export default [
  {
    text: "الموسم السادس والحالي",
    value: {
      start_date: "2025-11-01",
      end_date: "2027-01-15",
    },
  },
  {
    text: "الموسم الخامس",
    value: {
      start_date: "2025-04-15",
      end_date: "2025-10-30",
    },
  },
];